import { OrganizationType, Services, ServicesLabels } from '@consigli/types';
import { FC } from 'react';

import { Combobox, Field, Fieldset, Select, TextInput } from '@/components';

import { CreateOrganizationFormData, FormErrors } from './types';

interface BasicInformationFieldsProps {
  formData: CreateOrganizationFormData;
  errors: FormErrors;
  onFieldChange: (field: keyof CreateOrganizationFormData, value: unknown) => void;
}

const organizationTypeOptions = [
  { value: OrganizationType.CONTRACTOR, label: 'Contractor' },
  { value: OrganizationType.PRIVATE_REAL_ESTATE_OWNER, label: 'Private Real Estate Owner' },
  { value: OrganizationType.PUBLIC_REAL_ESTATE_OWNER, label: 'Public Real Estate Owner' },
  { value: OrganizationType.SUBCONTRACTOR, label: 'Subcontractor' },
  { value: OrganizationType.CONSULTANT, label: 'Consultant' },
];

const serviceOptions = Object.values(Services).map((service) => ({
  value: service,
  label: ServicesLabels[service],
}));

export const BasicInformationFields: FC<BasicInformationFieldsProps> = ({
  formData,
  errors,
  onFieldChange,
}) => {
  const handleServicesChange = (selectedServices: string[]) => {
    onFieldChange('availableServices', selectedServices as Services[]);
  };

  return (
    <Fieldset legend="Basic Information">
      <Field label="Name" htmlFor="organization-name-input" error={errors.name} required>
        <TextInput
          placeholder="Enter organization name"
          fullWidth
          value={formData.name}
          onChange={(e) => onFieldChange('name', e.target.value)}
        />
      </Field>

      <Field label="Type" htmlFor="organization-type-select" error={errors.type} required>
        <Select
          options={organizationTypeOptions}
          value={
            formData.type
              ? organizationTypeOptions.find((opt) => opt.value === formData.type)
              : null
          }
          onValueChange={(value) => onFieldChange('type', value?.value)}
          placeholder="Select organization type"
          className="w-full"
          getOptionLabel={(option) => option?.label || ''}
          getOptionValue={(option) => option?.value || ''}
          showSearch={true}
        />
      </Field>

      <Field
        label="Available Services"
        htmlFor="services-combobox"
        error={errors.availableServices}
        required
      >
        <Combobox
          optionGroups={[
            {
              label: 'Services',
              options: serviceOptions,
            },
          ]}
          fallbackLabel="No services found"
          placeholder="Select services..."
          value={formData.availableServices}
          onValueChange={handleServicesChange}
          className="w-full"
          search={true}
          searchPlaceholder="Search services..."
        />
      </Field>
    </Fieldset>
  );
};
